/* eslint-disable max-len */
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import ContainerPainel from 'components/container_painel';
import BottomActionButtons from 'components/shared/bottom_action_buttons';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IQuestoesAmbientais, useQuestoesAmbientaisStore } from 'stores/forms/questoes_ambientais.store';

const FormQuestoesAmbientaisEditar: React.FC = () => {
  const { uuid } = useParams();
  const { questoes, getQuestoes, setPartialForm, salvarRascunho, enviarAprovacao } = useQuestoesAmbientaisStore();
  const navigate = useNavigate();

  const [outroProblema, setOutroProblema] = useState({
    prioridade: null,
    descricao: '',
  });
  // Estado para controlar quais itens estão selecionados (checkbox)
  const [selectedIssues, setSelectedIssues] = useState<string[]>([]);
  const formik = useFormik({
    initialValues: {
      prioridadePoucosImoveisRegularizados: null,
      prioridadeSemTratamentoResiduos: null,
      prioridadeDegradacaoApp: null,
      prioridadeDegradacaoSolo: null,
      prioridadeDesmatamentoIlegal: null,
      prioridadePerdaBiodiversidade: null,
      prioridadeCriseHidrica: null,
      prioridadePoluicaoAgua: null,
      prioridadePoluicaoSolo: null,
      prioridadeQueimadas: null,
      prioridadeUsoAgrotoxicos: null,
      prioridadeMudancasClimaticas: null,
    },
    validate: (values) => {
      const errors: any = {};
      if (selectedIssues.length === 0) {
        errors.selectedIssues = 'Selecione pelo menos um problema ambiental';
      }

      for (const item of selectedIssues) {
        if (values[item as keyof typeof values] === null) {
          errors[item as keyof typeof values] = 'Selecione uma prioridade para o problema';
        }
      }

      return errors;
    },
    onSubmit: (values) => {
      handleSend();
    },
  })

  const handleSalvarComoRascunho = () => {
    const values = formik.values;
    setPartialForm('prioridadePoucosImoveisRegularizados', values.prioridadePoucosImoveisRegularizados);
    setPartialForm('prioridadeSemTratamentoResiduos', values.prioridadeSemTratamentoResiduos);
    setPartialForm('prioridadeDegradacaoApp', values.prioridadeDegradacaoApp);
    setPartialForm('prioridadeDegradacaoSolo', values.prioridadeDegradacaoSolo);
    setPartialForm('prioridadeDesmatamentoIlegal', values.prioridadeDesmatamentoIlegal);
    setPartialForm('prioridadePerdaBiodiversidade', values.prioridadePerdaBiodiversidade);
    setPartialForm('prioridadeCriseHidrica', values.prioridadeCriseHidrica);
    setPartialForm('prioridadePoluicaoAgua', values.prioridadePoluicaoAgua);
    setPartialForm('prioridadePoluicaoSolo', values.prioridadePoluicaoSolo);
    setPartialForm('prioridadeQueimadas', values.prioridadeQueimadas);
    setPartialForm('prioridadeUsoAgrotoxicos', values.prioridadeUsoAgrotoxicos);
    setPartialForm('prioridadeMudancasClimaticas', values.prioridadeMudancasClimaticas);
    setTimeout(() => {
      salvarRascunho();
      alert('Rascunho salvo com sucesso');
      handleSend();
    }, 100);
  }
  const makerIssues: {
    key: keyof IQuestoesAmbientais;
    label: string;
  }[] = [
      {
        key: 'prioridadePoucosImoveisRegularizados',
        label: 'Poucos imóveis rurais regularizados ambientalmente',
      },
      {
        key: 'prioridadeSemTratamentoResiduos',
        label: 'Ausência de tratamento de resíduos sólidos (lixo)',
      },
      {
        key: 'prioridadeDegradacaoApp',
        label: 'Degradação das Áreas de Preservação Permanente (APP)',
      },
      {
        key: 'prioridadeDegradacaoSolo',
        label: 'Degradação do solo (processos erosivos, compactação, aventização, perda de fertilidade etc.)',
      },
      {
        key: 'prioridadeDesmatamentoIlegal',
        label: 'Desmatamento ilegal e degradação florestal',
      },
      {
        key: 'prioridadePerdaBiodiversidade',
        label: 'Perda da biodiversidade',
      },
      {
        key: 'prioridadeCriseHidrica',
        label: 'Crise Hídrica e perca de água',
      },
      {
        key: 'prioridadePoluicaoAgua',
        label: 'Poluição e contaminação da água',
      },
      {
        key: 'prioridadePoluicaoSolo',
        label: 'Poluição e contaminação do solo',
      },
      {
        key: 'prioridadeQueimadas',
        label: 'Queimadas e incêndios florestais',
      },
      {
        key: 'prioridadeUsoAgrotoxicos',
        label: 'Uso indiscriminado de agrotóxicos',
      },
      {
        key: 'prioridadeMudancasClimaticas',
        label: 'Mudanças climáticas / Eventos extremos de seca e cheias',
      }
    ]

  const handleSend = async () => {
    Object.keys(formik.values).forEach(key => {
      setPartialForm(key as keyof typeof formik.values, formik.values[key as keyof typeof formik.values]);
    })

    setTimeout(async () => {
      const response = await enviarAprovacao();
      if (response) {
        navigate('/pacote-de-formularios');
      }
    }, 100);
  }

  const handleChangePriority = (key: keyof typeof formik.values, value: number | null) => {
    if (value === null) {
      formik.setFieldValue(key as keyof typeof formik.values, null);
      return;
    }

    const newValues: any = { ...formik.values };

    const itemSelecionado = newValues[key as keyof typeof newValues];
    const itemComMesmaPrioridade = Object.keys(newValues).find(key => newValues[key as keyof typeof newValues] === value);
    if (itemComMesmaPrioridade) {
      newValues[itemComMesmaPrioridade as keyof typeof newValues] = itemSelecionado;
    }
    newValues[key] = value;
    formik.setValues(newValues);
  }


  const handleGetQuestoes = async () => {
    const response = await getQuestoes(uuid as string);
    console.log("responseesso", response);

    const values: any = {
      prioridadePoucosImoveisRegularizados: response.prioridadePoucosImoveisRegularizados,
      prioridadeSemTratamentoResiduos: response.prioridadeSemTratamentoResiduos,
      prioridadeDegradacaoApp: response.prioridadeDegradacaoApp,
      prioridadeDegradacaoSolo: response.prioridadeDegradacaoSolo,
      prioridadeDesmatamentoIlegal: response.prioridadeDesmatamentoIlegal,
      prioridadePerdaBiodiversidade: response.prioridadePerdaBiodiversidade,
      prioridadeCriseHidrica: response.prioridadeCriseHidrica,
      prioridadePoluicaoAgua: response.prioridadePoluicaoAgua,
      prioridadePoluicaoSolo: response.prioridadePoluicaoSolo,
      prioridadeQueimadas: response.prioridadeQueimadas,
      prioridadeUsoAgrotoxicos: response.prioridadeUsoAgrotoxicos,
      prioridadeMudancasClimaticas: response.prioridadeMudancasClimaticas,
    }

    const issuesList: string[] = []
    Object.keys(values).forEach(key => {
      console.log('key', key)
      console.log('values[key as keyof typeof values]', values[key as keyof typeof values])

      if (values[key as keyof typeof values] !== null) {
        issuesList.push(key);
      }

    })
    setSelectedIssues(issuesList);
    formik.setValues(values);
  }

  useEffect(() => {
    handleGetQuestoes();
  }, []);

  // re renderizar o componente quando mudar o selectedIssues
  useEffect(() => {
    formik.validateForm();
  }, [selectedIssues]);

  return (
    <ContainerPainel
      pagina='Formulário de Questões Ambientais'
      showBackButton={true}
    >
      <Box sx={{ padding: 3 }}>
        {/* Header with green background and centered text */}
        <Box sx={{ backgroundColor: '#0048b6', p: 2, borderRadius: 1, mb: 3 }}>
          <Typography
            variant='h4'
            component='h1'
            align='center'
            sx={{ color: 'white' }}
          >
            CADASTRO DE QUESTÕES AMBIENTAIS
          </Typography>
          <Typography
            variant='subtitle1'
            align='center'
            sx={{ color: 'white' }}
          >
            Cadastro de Prioridades Ambientais do Município
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 3,
            ml: 7,
          }}
        >
          {/* Blue text with smaller font size */}
          <Typography
            variant='h5'
            gutterBottom
            sx={{ color: '#1976d2', fontSize: '0.9rem' }}
          >
            Assinale quais os problemas ambientais mais significativos no meio
            rural do município e defina a ordem de prioridade (1 para o mais significativo, 2 para o segundo
            mais significativo e assim por diante)
          </Typography>
        </Box>
        {/* Modified line with new text */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 3,
            ml: 7,
          }}
        >
          <Typography sx={{ mr: 2, fontWeight: 'bold' }}>
            Selecione os problemas existentes e defina suas prioridades:
          </Typography>
          <Typography sx={{ mr: 2 }}>Ano de referência: 2025</Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: '#f5f5f5',
            p: 2,
            mb: 3,
            borderRadius: 1,
            ml: 6,
          }}
        >
          <Typography variant='body2'>
            - Primeiro marque os problemas ambientais que existem no município
            <br />
            - Depois defina a prioridade de cada problema selecionado (1 = mais significativo)
            <br />
            - As prioridades são automáticas: se você selecionar uma prioridade já usada, ela será trocada automaticamente
            <br />- É necessário selecionar e priorizar pelo menos 1 item para prosseguir
          </Typography>
        </Box>

        <form onSubmit={formik.handleSubmit}>
          <Stack spacing={3} sx={{ ml: 6, mr: 6 }}>

            {
              Object.keys(formik.values).map((key, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Checkbox
                      checked={selectedIssues.includes(key)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          handleChangePriority(key as keyof typeof formik.values, selectedIssues.length + 1);
                          setSelectedIssues([...selectedIssues, key]);
                        } else {
                          const valorRemovido = formik.values[key as keyof typeof formik.values];
                          handleChangePriority(key as keyof typeof formik.values, null as any);
                          const novosSelectedIssues = selectedIssues.filter(item => item !== key);
                          setSelectedIssues(novosSelectedIssues);

                          // Reorganizar prioridades após remover um item
                          if (valorRemovido !== null) {
                            const newValues: any = { ...formik.values };
                            // Zerar o valor do item removido
                            newValues[key] = null;

                            // Reorganizar os outros itens que tinham prioridade maior
                            Object.keys(newValues).forEach(itemKey => {
                              const currentValue = newValues[itemKey];
                              if (currentValue !== null && currentValue > valorRemovido) {
                                newValues[itemKey] = currentValue - 1;
                              }
                            });

                            formik.setValues(newValues);
                          }
                        }
                      }}
                    />
                    <Typography>{makerIssues.find(issue => issue.key === key)?.label}</Typography>
                  </Box>

                  <FormControl sx={{ width: '400px', display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-end' }}>
                    <Select
                      value={formik.values[key as keyof typeof formik.values] || ''}
                      onChange={(e) => {
                        handleChangePriority(key as keyof typeof formik.values, Number(e.target.value));
                      }}
                      sx={{ width: '100px' }}
                      disabled={!selectedIssues.includes(key)}
                    >
                      {
                        Array.from({ length: selectedIssues.length }, (_, index) => (
                          <MenuItem key={index} value={index + 1}>{index + 1}</MenuItem>
                        ))
                      }
                    </Select>
                    <FormHelperText error={formik.errors[key as keyof typeof formik.values] !== undefined || formik.touched[key as keyof typeof formik.values]}>
                      {formik.errors[key as keyof typeof formik.values]}
                    </FormHelperText>
                  </FormControl>

                </Box>
              ))
            }

            {/* Other environmental issue */}
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  mb: 1,
                }}
              >
                <Typography sx={{ flex: 1, fontWeight: 'bold' }}>
                  Outro problema ambiental:
                </Typography>
                <FormControl sx={{ minWidth: 120 }}>
                  <Select
                    value={questoes.prioridadeOutroProblema || 0}
                    onChange={(e) => {
                      const value = e.target.value ? Number(e.target.value) : null;
                      setPartialForm('prioridadeOutroProblema', value);
                    }}
                    displayEmpty
                  >
                    <MenuItem value=''>Selecione</MenuItem>
                    <MenuItem value={13}>Sim</MenuItem>
                    <MenuItem value={0}>Não</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              {questoes.prioridadeOutroProblema === 13 && (
                <TextField
                  fullWidth
                  placeholder='Especifique outro problema ambiental...'
                  value={questoes.descricaoOutroProblema || ''}
                  onChange={(e) => setPartialForm('descricaoOutroProblema', e.target.value)}
                  sx={{ mt: 1 }}
                />
              )}
            </Box>
          </Stack>

          <Box
            sx={{
              mt: 4,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              ml: 6,
              mr: 6,
            }}
          >
            <Typography>
              {selectedIssues.length} problemas selecionados
            </Typography>

            <BottomActionButtons
              handleSalvarRascunho={handleSalvarComoRascunho}
              handleEnviarAprovacao={handleSend}
              isFormValid={formik.isValid}
              handleCancelar={() => navigate(-1)}
            />
          </Box>
        </form>
      </Box>
    </ContainerPainel>
  );
};

export default FormQuestoesAmbientaisEditar;
